/**
 * @generated SignedSource<<152cd52a29d53dd4a5f01e3b100e1d30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LockedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly lockReason: LockReason | null;
  readonly " $fragmentType": "LockedEvent";
};
export type LockedEvent$key = {
  readonly " $data"?: LockedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"LockedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LockedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LockedEvent",
  "abstractKey": null
};

(node as any).hash = "f166d7a627694872d8045efcc54a7b45";

export default node;
